/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringEnumChoicesDto } from '../../models/backend-monitoring-enum-choices-dto';

export interface MonitoringCommonEnumsRetrieve$Params {}

export function monitoringCommonEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringCommonEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMonitoringEnumChoicesDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringCommonEnumsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMonitoringEnumChoicesDto>;
    }),
  );
}

monitoringCommonEnumsRetrieve.PATH = '/api/monitoring/common/enums/';
